<template>
    <div  name="poll" class="flex">
      <button v-for="object in answers" :key="object.identifier" @click="answerSelected(object)" class="py-2 px-4 text-base rounded-lg m-3 semi-bold capitalize cursor-pointer hover:opacity-50"
      :class="isSelected(object) ? 'bg-action-blue  bg-opacity-50 text-white border border-blue-400' :  'bg-gray-100 text-gray-600 border border-gray-200'">
        {{ object.answer.content }}
        </button>
    </div>
</template>

<script>
export default {
  name: "poll",
  data() {
    return {
      setAnswers: []
    };
  },
  props: {
    answers: { type: Array, required: false },
    selectedAnswers: { type: Array, required: true },
  },
  computed: {
   
  },
  watch: {
   
  },
  created() {
  },
  mounted() {
    if (this.selectedAnswers != undefined) {
      this.setAnswers = this.selectedAnswers
    }
  },
  methods: {
   isSelected(object) {
    return this.setAnswers.find((aa) => {
      return object.wb_survey_question_identifier === aa.survey_answer.wb_survey_question_identifier && 
        object.answer.key_value === aa.survey_answer.answer.key_value
    })
   },
   answerSelected(object) {
    if (this.setAnswers.some(aa => object.wb_survey_question_identifier === aa.survey_answer.wb_survey_question_identifier)){
           this.setAnswers.splice(this.setAnswers.findIndex(item => object.wb_survey_question_identifier === item.survey_answer.wb_survey_question_identifier), 1)
    }

    let payload = {survey_answer: object}
  this.setAnswers.push(payload)
  this.$emit("answerSelected", payload);

   }
  }
};
</script>

<style>

</style>
